import moment from "moment";
import { IParam } from "./api/IDataResponse";

export const formatValue = (record: IParam, decimalDigits: number, calc: ((v: number) => number) = (v => v)) => {

    const timeSinceReceived = moment().unix() * 1e3 - record.timestamp // [ms]
    
    let value: string;
    
    if (!record) {
        value = "ERR";
    } else if (timeSinceReceived > 60*60*1e3) {
        // if record was received more than 60 minutes ago
        value = "///"
    } else {
        value = record.value;
        if (decimalDigits !== undefined) {
            const dval = parseFloat(value);
            if (!isNaN(dval)) {
                value = (calc(dval)).toFixed(decimalDigits);
            }
        }
    }

    return value
}